var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVclose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5001 17.2483L21.4932 22.2415C21.8379 22.5862 22.3968 22.5862 22.7415 22.2415C23.0862 21.8967 23.0862 21.3379 22.7415 20.9931L17.7483 16L22.7415 11.0068C23.0862 10.6621 23.0862 10.1032 22.7415 9.75854C22.3968 9.41383 21.8379 9.41383 21.4932 9.75854L16.5001 14.7517L11.5068 9.75853C11.1621 9.41382 10.6032 9.41382 10.2585 9.75853C9.91382 10.1032 9.91382 10.6621 10.2585 11.0068L15.2517 16L10.2585 20.9932C9.91382 21.3379 9.91382 21.8967 10.2585 22.2415C10.6032 22.5862 11.1621 22.5862 11.5068 22.2415L16.5001 17.2483Z",
    fill: "#21272C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVclose);
export default __webpack_public_path__ + "static/media/vclose.43aa9d422a53ea1fc3fc4f7e5acbda17.svg";
export { ForwardRef as ReactComponent };